export default __webpack_public_path__ + "static/vuejs-development-company-peerbits-69a8cb9fe44391db9a4c1b89b652ad52.png";